<template>
    <div class="full-size not-found">
        <img id="logo"
             class="logo"
             src="~/images/logo.png"
        >
        <p> {{ i18n.t("info_404")}}</p>
    </div>
</template>

<script>

import {inject} from "vue";

export default {

  setup(props, context) {

      const i18n = inject("i18n")

      return {
          i18n
      }
  }

}
</script>

<style scoped lang="scss">

    .not-found {
        display: flex;
        justify-content: center;
        align-items: center;
        background:$color-primary;
        flex-direction: column;

        .logo {
            display:block;
            width:316px;
        }

        p {
            margin:20px 0;
            color:$color-primary-lighter;
            font-size:15px;
        }
    }

</style>
